import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from 'components/Spinner'
import Layout from 'components/Layout'
import MyPartnerAppCards from './MyPartnerAppCards'
import { initializeMyPartnerApps } from 'slices/myPartnerAppSlice'

const PartnerApps_Index = () => {
	const dispatch = useDispatch()

	const {
		entities: appEntities,
		ids: myPartnerAppIds,
		isLoading: myPartnerAppsLoading,
		isInitialized: myPartnerAppsInitialized,
	} = useSelector(state => state.myPartnerApps)
	const partnerApps = myPartnerAppIds.map(id => appEntities[id])

	useEffect(() => {
		dispatch(initializeMyPartnerApps())
	}, [dispatch])

	return (
		<React.Fragment>
			<Layout.PageToolbar
				buttonText="Explore Apps"
				// buttonOnClick={() => setOpenPopup(true)}
				// searchInputRef={searchInputRef}
				// searchInputValue={searchInputValue}
				// searchInputOnChange={handleSearch}
			/>
			{myPartnerAppsInitialized ? (
				<div>
					<MyPartnerAppCards partnerApps={partnerApps} />
				</div>
			) : (
				<Spinner containerHeight="50vh" />
			)}
		</React.Fragment>
	)
}

export default PartnerApps_Index
